import { Component, Vue } from "vue-property-decorator";
import { IndexHeader } from "@/components/IndexHeader";
import { IndexFooter } from "@/components/IndexFooter";
import { ConnectInlet } from "@/components/ConnectInlet";
import { _isMobile } from "@/libs/tools";
import { PointParamsD } from "@/Module/pointParams";
import { Points } from "@/Module/point";
import { getPoint } from "@/api/seller";
import {
    Banner,
    Policy,
    Mode,
    SimpleImg,
    LiuCheng,
    FirstStage,
    SecondStage,
    Teacher,
    Job,
    Welfare,
    OnlyImage,
    Qa
} from "@/pages/detailsEmployment/commponents";

Component.registerHooks(["asyncData"]);
@Component({
    components: {
        IndexHeader,
        IndexFooter,
        ConnectInlet,
        Banner,
        Policy,
        Mode,
        SimpleImg,
        LiuCheng,
        FirstStage,
        SecondStage,
        Teacher,
        Job,
        Welfare,
        OnlyImage,
        Qa
    }
})
export default class DetailEmployment extends Vue {
    private seriesId: number | undefined = 60;
    private pageConfig: any = {};
    private productId: number | undefined;
    private pointParams: PointParamsD = {
        pageType: 2,
        pageKey: Points[""],
        source: "",
        productId: 0,
        courseId: 0
    };
    asyncData({ store, route }) {
        return store.dispatch("detailsPage/fetchInfoEmployment", {
            courseSeriesId: 60
        });
    }
    get detailsData() {
        return this.$store.state.detailsPage.detailsData;
    }
    handlePoint(key) {
        this.pointParams.pageKey = Points[key];
        getPoint(this.pointParams);
    }
    created(): void {
        // this.seriesId = Number(this.$route.params.courseSeriesId);
    }
    mounted() {
        this.productId = this.detailsData.currentProduct.productCourses[0].productId;
        this.pageConfig = JSON.parse(
            this.detailsData.currentPageConfig.pageConfig
        );
        this.pointParams.pageType = _isMobile() ? 1 : 2;
        this.pointParams.productId = this.productId;
        this.pointParams.courseId = this.detailsData.course.id;
        document.documentElement.scrollTop = 0;
        localStorage.setItem("toPath", location.href);
        this.handlePoint("INFO_PAGE_VIEW");
    }
}
